export default "__VITE_ASSET__SCjXjTh0__"